import { render, staticRenderFns } from "./myPlan.vue?vue&type=template&id=a1035d00"
import script from "./myPlan.vue?vue&type=script&lang=js"
export * from "./myPlan.vue?vue&type=script&lang=js"
import style0 from "./myPlan.vue?vue&type=style&index=0&id=a1035d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports